
const reduceHistory = (state = {
    pageviewsQueyHistory: [],
}, action)=>{
	return state;
};

export default reduceHistory;